module.exports = __webpack_public_path__ + "img/serifnew_box29.2a761524.jpg";